import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { useRoute } from 'lib/route-provider';
import { emailSchema } from 'lib/validation';
import application from 'lib/application';
import Button from 'components/button';
import { P } from 'components/text';
import UnexpectedError from 'components/error/UnexpectedError';
import StartForm from 'forms/start';

const LoginText = styled(P)`
  margin-top: ${props => props.theme.paddingXS};
  font-size: ${props => props.theme.fontSizeXS};
`

export const HelpSection = styled.div`
  * {
    font-size: ${props => props.theme.fontSize14};
  }

  ul {
    padding-left: ${props => props.theme.paddingS};
  }

  li {
    color: ${props => props.theme.primaryText};
    margin-bottom: ${props => props.theme.paddingXXS};
    
    /* override the bullet point size */
    list-style-type: none;
    position: relative;
    &::before {
      content: '•';
      position: absolute;
      left: -1rem;
      font-size: 1.1rem;
    }
  }
`;

const Start = () => {
  const [hasApiError, setHasApiError] = useState(false);
  const { goToNextStep } = useRoute();
  
  const handleSubmit = async (values, actions) => {
    let response;
    try {
      response = await application.create(values);
    } catch (e) {
      setHasApiError(true);
    }

    if (response && !response.error) {
      goToNextStep(values);
      
      // not pretty, but this ensures the submit button stays disabled during
      // the transition to the next screen
      await new Promise(resolve => setTimeout(resolve, 200))
    }
    
    if (response && response.error) {
      actions.setErrors(response.error.message)
    }
  }
  
  return (
    <Formik
      initialValues={{email: ''}}
      onSubmit={handleSubmit}
      validationSchema={emailSchema}
    >
    {({ isSubmitting }) => (
      <Form>
        <StartForm />
        
        {hasApiError && (
          <UnexpectedError>
            There was an error signing you up. Please check our{' '}<a
                      href="https://status.ledgerx.com/"
                      target="_blank"
                      rel="noopener noreferrer"
            >support page</a>{' '}for system status.
          </UnexpectedError>
        )}

        <Button primary type="submit" disabled={isSubmitting}>
          Continue
        </Button>
        
        <LoginText>
          Already have an account?&nbsp;
          <a href="https://omni.ledgerx.com" target="_blank" rel="noopener noreferrer">
            Login here.
          </a>
        </LoginText>
        
        <HelpSection>
          <P>
            Trading on LedgerX is currently available to:
          </P>
          <ul>
            <li>
              All United States (US) individuals
            </li>
            <li>
              United States (US), Cayman Islands, or British Virgin Islands (BVI) entities
            </li>
            <li>
              Entities wholly owned or managed by a United States entity/individual
            </li>
            <li>
              National Futures Association (NFA) registered entity/individual
            </li>
          </ul>
        </HelpSection>
      </Form>
    )}
    </Formik>
  );
}

export default Start;
